import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import IconArrowDown from 'ui/Icons/IconArrowDown'
import IconSearch from 'ui/Icons/IconSearch'

export const SelectToggle = ({
  id,
  ref,
  name,
  search,
  placeholder,
  isSelected,
  searchable,
  readOnly,
  isInvalid,
  loading,
  showArrow,
  color,
  onBlur,
  onFocus,
  onSearchChange,
}) => {
  const isReadOnly = useMemo(() => {
    if (loading) {
      return true
    }

    if (searchable) {
      return false
    }

    return readOnly
  }, [loading, readOnly, searchable])

  return (
    <InputGroup
      id={id}
      className={[
        'x-select',
        {
          'is-loading': loading,
          'is-searchable': searchable,
        },
        color ? 'is-color-' + color : '',
      ]}
    >
      <FormControl
        ref={ref}
        name={name}
        value={search}
        placeholder={placeholder}
        readOnly={isReadOnly}
        className={{ selected: isSelected }}
        isInvalid={isInvalid}
        onBlur={() => onBlur(name)}
        onChange={onSearchChange}
        onFocus={onFocus}
      />
      {searchable && <IconSearch />}

      <InputGroup.Append
        className={{
          'is-invalid': isInvalid,
          selected: isSelected,
        }}
      >
        {showArrow && !loading && (
          <IconArrowDown color={isSelected ? '#222222' : '#A3A3A3'} />
        )}
      </InputGroup.Append>
    </InputGroup>
  )
}

// Props
SelectToggle.propTypes = {
  ref: PropTypes.any,
  id: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
  search: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  searchable: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  showArrow: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onSearchChange: PropTypes.func,
}

SelectToggle.defaultProps = {
  ref: null,
  id: '',
  color: '',
  name: '',
  search: '',
  placeholder: '',
  readOnly: true,
  searchable: false,
  isInvalid: false,
  isSelected: false,
  loading: false,
  showArrow: true,
  onBlur: () => {},
  onFocus: () => {},
  onSearchChange: () => {},
}

export default SelectToggle
